import React from 'react';
import { Card } from 'reactstrap';
import { HashLink } from 'react-router-hash-link';
import ControlPanelIcon from 'components/atoms/icons/controlPanelIcon';
import QuestionnaireIcon from 'components/atoms/icons/questionnaireIcon';
import MedicalHistoryIcon from 'components/atoms/icons/medicalHistoryIcon';
import ClinicalActivityIcon from 'components/atoms/icons/clinicalActivityIcon';
import MedicationIcon from 'components/atoms/icons/medicationIcon';
import PatientGoalsIcon from 'components/atoms/icons/patientGoalsIcon';
import UserProfileIcon from 'components/atoms/icons/userProfileIcon';

const MiniNav = () => (
  <Card className="mini-nav">
    <HashLink smooth to="#control-panel">
      <div className="mini-nav__item">
        <ControlPanelIcon />
        <span className="mini-nav__item-title">Control Panel</span>
      </div>
    </HashLink>
    <HashLink smooth to="#questionnaire">
      <div className="mini-nav__item">
        <QuestionnaireIcon />
        <span className="mini-nav__item-title">Questionnaire</span>
      </div>
    </HashLink>
    <HashLink smooth to="#medical-history">
      <div className="mini-nav__item">
        <MedicalHistoryIcon />
        <span className="mini-nav__item-title">Medical History</span>
      </div>
    </HashLink>
    <HashLink smooth to="#clinical-activity">
      <div className="mini-nav__item">
        <ClinicalActivityIcon />
        <span className="mini-nav__item-title">Clinical Activity</span>
      </div>
    </HashLink>
    <HashLink smooth to="#medication">
      <div className="mini-nav__item">
        <MedicationIcon />
        <span className="mini-nav__item-title">Medication</span>
      </div>
    </HashLink>
    <HashLink smooth to="#patient-goals">
      <div className="mini-nav__item">
        <PatientGoalsIcon />
        <span className="mini-nav__item-title">Patient Goals</span>
      </div>
    </HashLink>
    <HashLink smooth to="#user-profile">
      <div className="mini-nav__item">
        <UserProfileIcon />
        <span className="mini-nav__item-title">Patient Profile</span>
      </div>
    </HashLink>
  </Card>
);

export default MiniNav;
